import * as React from 'react';
import type { ClientApprovalBucketItem } from 'types';

type ContextType = {
  type: string,
  items: Array<ClientApprovalBucketItem>
} | null;

const ClientApprovalContext = React.createContext<ContextType>(null);

export default ClientApprovalContext;
